export const CUPONERA = "CuponPago";
export const DEBITO_CBU = "DebitoConCBU";
export const DEBITO_TARJETA_CREDITO = "DebitoConTarjetaCredito";
